<template>
  <div class="modalfooter">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style>
.modalfooter {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  margin: 0;
  height: 70px;
}
</style>